<div class="field grid">
    <div class="col-1"></div>
    <label for="accountField.value" class="col-fixed label" style="width: 15em">{{accountField.key}}:</label>
    <div class="col">
        <input pInputText [id]="accountField.key" [readonly]="true" [(ngModel)]="accountField.value"  [style]="{'width': '100%'}"/> 
    </div>
</div>
